import Link from 'next/link';
import styled from 'styled-components';
import { useSelector } from 'src/store/store';
import i18n from 'src/utils/translate';
import Icon from 'src/components/icon';
import { titleSmall } from 'styles-js/mixins/typography';

export default function ModuleList({ handleClick }: { handleClick: () => void }) {
  const { details = {}, currentModule, modules } = useSelector(({ pages }) => pages.programs);
  const { code: programCode } = details;
  const currentModuleCode = currentModule?.currentCode || null;

  return (
    <ModuleListContainer>
      <ModuleListItem>
        <Link
          as={`/programs/${programCode}`}
          href={`/programs?slug=${programCode}`}
          scroll={false}
          onClick={handleClick}
        >
          <NumberTag>{'0'}</NumberTag>
          <ModuleName selected={!currentModuleCode}>{i18n.t('About this program')}</ModuleName>
        </Link>
      </ModuleListItem>
      {modules.map(module => (
        <ModuleListItem key={module.sort}>
          <Link
            as={`/programs/${programCode}/${module.code}`}
            href={`/programs?slug=${programCode}&moduleCode=${module.code}`}
            scroll={false}
            onClick={handleClick}
          >
            <NumberTag>
              {module.sections.some(({ isCompleted }) => !isCompleted)
                ? <>{module.sort}</>
                : <Icon colour="colorGreen" icon="ok" />
              }
            </NumberTag>
            <ModuleName selected={currentModuleCode === module.code}>{i18n.t(module.name)}</ModuleName>
          </Link>
        </ModuleListItem>
      ))}
    </ModuleListContainer>
  );
}

const ModuleListContainer = styled.ul`
  list-style: none;
  background-color: ${props => props.theme.colorWhite};
  padding: 10px 0;

  @media (${props => props.theme.underScreenMedium}) {
    background-color: ${props => props.theme.colorBlueBackground};
    padding: 10px 20px;
  }

  @media (${props => props.theme.underScreenXxsmall}) {
    padding: 10px 15px;
  }
`;

const ModuleListItem = styled.li`
  margin-bottom: 5px;
  overflow: hidden;
`;

const ModuleName = styled.span<{ selected: boolean }>`
  ${titleSmall};
  float: left;
  width: calc(100% - 38px);
  margin-top: 4px;
  color: ${props => props.selected ? props.theme.colorGreyDark : props.theme.colorBlack};
`;

const NumberTag = styled.div`
  float: left;
  color: ${props => props.theme.colorTextLinkPrimary};
  background-color: ${props => props.theme.colorBlueBackground};
  width: 28px;
  line-height: 28px;
  text-align: center;
  border-radius: 50%;
  margin-right: 10px;
  font-family: ${props => props.theme.fontFamilyTitle};

  @media (${props => props.theme.underScreenMedium}) {
    background-color: ${props => props.theme.colorWhite};
  }
`;

